const _excluded = ["onChange", "value", "readOnly", "disabled", "dateFormat"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { InputFlatpickrInline } from "./flatpickr";
import { defaultDateFormat } from "./input-date.vm";
export const InputDateSingle = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      onChange,
      value,
      readOnly,
      disabled,
      dateFormat = defaultDateFormat
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputFlatpickrInline, _extends({}, rest, {
    ref: ref,
    value: value,
    readOnly: readOnly,
    disabled: disabled,
    onChange: (_, dateStr) => {
      dateStr && onChange && onChange(dateStr);
    },
    dateFormat: dateFormat,
    mode: "single"
  })));
});